<template>
  <div>
    <v-card
      class="mb-5 pa-5"
      data-cy="card_ingresso_digital"
    >
      <p class="mb-5 grey--text text--darken-2">
        Gere seu ingresso digital e garanta acesso ao evento!
      </p>
      <v-btn
        :href="linkIngressoDigital"
        block
        class="mb-4"
        color="primary"
        data-cy="btn_ingresso_digital"
        target="_blank"
      >
        Ingresso Digital
      </v-btn>
    </v-card>
  </div>
</template>
<script>
export default {
  name: 'CardIngressoDigital',

  props: {
    dadosDaCompra: {
      type: Object,
      required: true,
    },
  },

  computed: {
    linkIngressoDigital() {
      if (this.dadosDaCompra && this.dadosDaCompra.ticket_link) {
        return this.dadosDaCompra.ticket_link;
      }
      return '/minhas-compras';
    },
  },

};
</script>
